import { useState } from "react";
import { useTranslation } from "react-i18next";
import ToolButton from "./ToolButton";
import ExoAlert from "../../exo/ExoAlert";

const ClearTool = ({
  mapElements,
  selectedElement,
  active,
  onClick,
  setMapElements,
  setProjectAreas,
  onAlert,
  open,
  currentMode,
  onlyProjectAreas,
  onClear,
}) => {
  const { t } = useTranslation();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const toolElementMap = {
    nodeTool: "node",
    edgeTool: "edge",
    areaTool: "area",
  };

  function handleClear() {
    if (onlyProjectAreas) {
      setProjectAreas([]);
    } else {
      setMapElements([]);
      if (currentMode === "projectAreaTool") {
        setProjectAreas([]);
      }
    }

    // clearing empties mapElements, so the "unsaved elements" check no longer
    // catches it — flag the clear so opening the actions menu still forces a
    // save (otherwise an action would run against the stale, un-cleared data)
    if (onClear) onClear();

    setConfirmOpen(false);
    onClick();
  }
  return (
    <>
      <ToolButton
        src={"/assets/svg/tools/clear.svg"}
        label="Clear"
        onClick={() => setConfirmOpen(true)}
        active={active}
        open={open}
        variant="warning"
      />
      <ExoAlert
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onSubmit={handleClear}
        alert={{
          type: "warning",
          message: t(
            "Do you really want to clear everything? This cannot be undone."
          ),
          submitLabel: t("Clear"),
          cancleLabel: t("Cancle"),
        }}
      />
    </>
  );
};
export default ClearTool;
